import { useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { Field, Primary, inputCls } from "@/components/backoffice/kit";

/** 6.3 — the collapsed Fulfillment (private) box on a line the viewer prints. Never leaves the back office. */
export default function FulfillmentBox({ orderId, item, options, endpoint, onSaved }) {
    const plan = item.fulfillment_plan || {};
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState({ method: plan.method || "", supplier: plan.supplier || "", cost: plan.cost ?? "", notes: plan.notes || "" });
    const [busy, setBusy] = useState(false);
    const save = async () => {
        setBusy(true);
        try {
            const url = endpoint || `/vendor/orders/${orderId}/items/${item.uid}/fulfillment`;
            const { data } = await api.put(url, { ...form, cost: form.cost === "" ? null : Number(form.cost) });
            toast.success("Saved — private to your shop");
            onSaved?.(data.order);
            setOpen(false);
        } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); } finally { setBusy(false); }
    };
    const summary = [plan.method, plan.supplier, plan.cost != null ? `$${Number(plan.cost).toFixed(2)}` : null].filter(Boolean).join(" · ");
    return (
        <div className="border border-dashed border-[#767676] bg-white" data-testid={`fulfillment-box-${item.uid}`}>
            <button onClick={() => setOpen((v) => !v)} data-testid={`fulfillment-toggle-${item.uid}`}
                className="flex min-h-[44px] w-full items-center justify-between px-3 text-left text-[15px]">
                <span className="font-semibold">Fulfillment (private)</span>
                <span className="text-[#4d4d4d]">{summary || "not set"} {open ? "▴" : "▾"}</span>
            </button>
            {open && (
                <div className="grid gap-3 border-t border-[#767676] p-3 sm:grid-cols-2">
                    <Field label="Method">
                        <select className={inputCls} value={form.method} onChange={(e) => setForm({ ...form, method: e.target.value })} data-testid={`fulfillment-method-${item.uid}`}>
                            <option value="">—</option>{(options?.methods || []).map((m) => <option key={m}>{m}</option>)}
                        </select>
                    </Field>
                    <Field label="Supplier">
                        <select className={inputCls} value={form.supplier} onChange={(e) => setForm({ ...form, supplier: e.target.value })} data-testid={`fulfillment-supplier-${item.uid}`}>
                            <option value="">—</option>{(options?.suppliers || []).map((s) => <option key={s}>{s}</option>)}
                        </select>
                    </Field>
                    <Field label="Cost ($)"><input type="number" inputMode="decimal" step="0.01" className={inputCls} value={form.cost} onChange={(e) => setForm({ ...form, cost: e.target.value })} data-testid={`fulfillment-cost-${item.uid}`} /></Field>
                    <Field label="Notes"><input className={inputCls} value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} data-testid={`fulfillment-notes-${item.uid}`} /></Field>
                    <div className="sm:col-span-2"><Primary onClick={save} disabled={busy} testid={`fulfillment-save-${item.uid}`}>Save</Primary></div>
                </div>
            )}
        </div>
    );
}
